<template>
  <div class="mc-content-empty-small">
    <div class="mc-content-empty-top" />
    <div class="mc-content-empty-center">
      <img @error="imgError" class="mc-content-empty-img-small" src="@/assets/img/nodata.png" alt />
    </div>
    <div class="mc-content-empty-bottom" />
  </div>
</template>

<script>
export default {
  name: "EmptyData",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped lang="scss">
@import '~@/assets/styles/mcstyle.scss';
</style>
